module.exports = __webpack_public_path__ + "static/media/purpose2.7edc0ee7.svg";